import React from 'react';

function EyeHideIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M1.2,2.2C0.9,1.9,0.4,2,0.2,2.3S0,3.1,0.3,3.3l18.5,14.5c0.3,0.3,0.8,0.2,1.1-0.1s0.2-0.8-0.1-1.1l-3.3-2.6c1.2-1.3,2.1-2.7,2.5-3.7c0.1-0.2,0.1-0.5,0-0.8c-0.5-1.1-1.4-2.7-2.9-4.1C14.5,4.2,12.5,3,10,3C7.9,3,6.1,3.8,4.7,4.9L1.2,2.2zM7,6.7c0.8-0.7,1.9-1.2,3-1.2c2.5,0,4.5,2,4.5,4.5c0,0.8-0.2,1.5-0.5,2.1l-1.2-0.9c0.3-0.6,0.3-1.3,0.1-2c-0.3-1.3-1.5-2.2-2.8-2.2C9.9,7,9.8,7.2,9.9,7.4C10,7.6,10,7.8,10,8c0,0.3-0.1,0.6-0.2,0.9L7,6.7L7,6.7z M11.7,14.2c-0.5,0.2-1.1,0.3-1.7,0.3c-2.5,0-4.5-2-4.5-4.5c0-0.2,0-0.4,0-0.6L2.6,7C1.9,8,1.4,8.9,1.1,9.6C1,9.9,1,10.1,1.1,10.4c0.5,1.1,1.4,2.7,2.9,4.1c1.5,1.4,3.5,2.5,6,2.5c1.5,0,2.8-0.4,3.9-1L11.7,14.2z"/>
    </svg>
  );
}

export default EyeHideIcon;
